import { render } from "./AccountOnHold.vue?vue&type=template&id=1e967a3a"
import script from "./AccountOnHold.vue?vue&type=script&lang=js"
export * from "./AccountOnHold.vue?vue&type=script&lang=js"

import "./AccountOnHold.vue?vue&type=style&index=0&id=1e967a3a&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__